import { CalculatorConfig } from '@/types/calculator';

// Salary Calculator Configuration
export const SALARY_CALCULATOR_CONFIG: CalculatorConfig = {
  id: 'salary-calculator',
  name: 'Education & Career Settings',
  title: 'How Does Your Salary Compare?',
  description:
    'Find out where you stand in terms of earnings compared to your industry peers.',
  subhed:
    'Explore the salaries below to get a better understanding of your earning potential.',
  formTitle: 'Start by entering your education goals and current salary:',
  ctaText: 'Explore Salaries',
  maxColumns: 3,
  fields: [
    {
      key: 'degree',
      type: 'select',
      label: 'My next degree',
      placeholder: 'Select a degree',
      required: true,
      validation: (value) => !!value || 'Please select a degree',
    },
    {
      key: 'category',
      type: 'select',
      label: 'My field',
      placeholder: 'Select a category',
      required: true,
      dependsOn: ['degree'],
      validation: (value) => !!value || 'Please select a category',
    },
    {
      key: 'subject',
      type: 'select',
      label: 'Subject',
      placeholder: 'Select a subject',
      required: true,
      dependsOn: ['category'],
      validation: (value) => !!value || 'Please select a subject',
    },
    {
      key: 'currentSalary',
      type: 'number',
      label: 'My current salary',
      placeholder: '$ Current salary',
      required: true,
      validation: (value) =>
        !value ||
        (typeof value === 'number' && value > 0) ||
        'Salary must be greater than 0',
      formatting: (value) =>
        value ? new Intl.NumberFormat().format(value as number) : '',
    },
  ],
  tracking: {
    formatSubtype: 'salary-calculator-entry',
    location: 'salary-calculator',
    formName: 'salary-calculator-v2',
    formType: 'salary-calculator',
    name: 'salary-calculator-v2',
    position: 'salary-calculator',
    cardformatSubtype: 'salary-calculator-card',
  },
  defaultValues: {
    degree: '',
    category: '',
    subject: '',
    currentSalary: null,
  },
  useDynamicDropdowns: true,
};
